export const RouterEnum = {
    Customize: {
        path: '/customize',
        name: 'Customize',
        Menu: {
            path: 'menu',
            name: 'CustomizeMenu',
        },
        AutoReplay: {
            path: 'auto-replay',
            name: 'AutoReplayManagement',
        },
        Accounts: {
            path: 'gzh-accounts',
            name: 'GzhAccountManagement',
        },
    },
    SignIn: {
        path: '/signin',
        name: 'Signin',
    },
    Dashboard: {
        path: '/dashboard',
        name: 'Dashboard',
    },
    ItemManagement: {
        path: '/item',
        name: 'Item',
        ItemList: {
            path: 'list',
            name: 'ItemList',
        },
        AddItem: {
            path: 'add',
            name: 'AddItem',
        },
        ModifyItem: {
            path: 'modify/:itemId',
            name: 'ModifyItem',
        }
    },
    ProductManagement: {
        path: '/china/product-list',
        name: 'ProductsList',
    },
    Certificate: {
        path: '/china/certificate',
        name: 'Certificate',
        CertificateList: {
            path: 'list',
            name: 'CertificateList'
        }
    },
    CertificateWorkOrder: {
        path: '/certificate-work-order',
        name: 'CertificateWorkOrder',
    },
    // 병원 도메인 작업지시서 조회 (SPEC-CHINA-HOSPITAL-WO-READ-001)
    HospitalWorkOrders: {
        path: '/hospital-work-orders',
        name: 'HospitalWorkOrders',
        Manual: {
            path: 'manual',
            name: 'HospitalManualOrders',
        },
        Hengjiu: {
            path: 'hengjiu',
            name: 'HospitalHengjiuOrders',
        },
    },
    Follower: {
        path: '/follower',
        name: 'Follower',
        FollowerList: {
            path: 'list',
            name: 'FollowerList'
        },
        FollowerStats: {
            path: 'stats',
            name: 'FollowerStats'
        }
    },
    // 병원관리 (SPEC-CHINA-ADMIN-HOSPITAL-001)
    Hospital: {
        path: '/hospital',
        name: 'Hospital',
        List: {
            path: 'list',
            name: 'HospitalList',
        },
    },
    // 기공소관리 (SPEC-CHINA-ADMIN-HOSPITAL-001)
    DentalLab: {
        path: '/dental-lab',
        name: 'DentalLab',
        List: {
            path: 'list',
            name: 'DentalLabList',
        },
    },
    // EcountEtl 운영 콘솔 (SPEC-ECOUNT-ETL-OPS-CONSOLE-001)
    EcountEtl: {
        path: '/ecount-etl',
        name: 'EcountEtl',
        Dashboard: {
            path: 'dashboard',
            name: 'EcountEtlDashboard',
        },
        Runs: {
            path: 'runs',
            name: 'EcountEtlRuns',
        },
        RunDetail: {
            path: 'runs/:runId',
            name: 'EcountEtlRunDetail',
        },
        DeadLetters: {
            path: 'dead-letters',
            name: 'EcountEtlDeadLetters',
        },
        Products: {
            path: 'products',
            name: 'EcountEtlProducts',
        },
        Transactions: {
            path: 'transactions',
            name: 'EcountEtlTransactions',
        },
        // 거래상세 (SPEC-CHINA-ECOUNT-SALES-LINES-001)
        SalesLines: {
            path: 'sales-lines',
            name: 'EcountEtlSalesLines',
        },
        SyncTrigger: {
            path: 'sync-trigger',
            name: 'EcountEtlSyncTrigger',
        },
    },
    // Lab Orders 헝지우 작업지시서 (SPEC-CHINA-LAB-ORDERS-READ-001)
    // + 수기 작업지시서 목록 (SPEC-CHINA-LAB-MANUAL-WORKORDER-LIST-001)
    LabOrders: {
        path: '/lab-orders',
        name: 'LabOrders',
        Hengjiu: {
            path: 'hengjiu',
            name: 'HengjiuWorkOrders',
        },
        Manual: {
            path: 'manual',
            name: 'ManualWorkOrders',
        },
    },
    // Lot/Batch 통합 추적 (SPEC-CHINA-LOT-BATCH-TRACEABILITY-001)
    LotTrace: {
        path: '/lot-trace',
        name: 'LotTrace',
    },
    // SPEC-CHINA-LOT-FLOW-DASHBOARD-001: 흐름 현황판 (REQ-FE-DASH-001)
    LotFlowDashboard: {
        path: '/lot-status',
        name: 'LotFlowDashboard',
    },
    // SPEC-CHINA-DEALER-DASHBOARD-001: 딜러사 전용 대시보드 (REQ-FE-001, 로그인 랜딩)
    DealerDashboard: {
        path: '/dealer-dashboard',
        name: 'DealerDashboard',
    },
    // SPEC-CHINA-HQ-DASHBOARD-001: 덴탈맥스 본사 전용 대시보드
    HqDashboard: {
        path: '/hq-dashboard',
        name: 'HqDashboard',
    },
    // 실물인증서 카드 발번·이력·정품조회 (SPEC-CHINA-CERT-CARD-ISSUE-001)
    CertificateCard: {
        path: '/certificate-card',
        name: 'CertificateCard',
        Issue: {
            path: 'issue',
            name: 'CertificateCardIssue',
        },
        Batches: {
            path: 'batches',
            name: 'CertificateCardBatches',
        },
        Verify: {
            path: 'verify',
            name: 'CertificateCardVerify',
        },
        // 견적표 관리 화면 (SPEC-CHINA-CERT-CARD-QUOTATION-UX-001)
        Quotation: {
            path: 'quotation',
            name: 'CertificateCardQuotation',
        },
    },
    // 제조사 실무자 통합 관리 (SPEC-CHINA-MFR-STAFF-ACCOUNT-001)
    MfrStaffManage: {
        path: '/mfr-staff-manage',
        name: 'MfrStaffManage',
    },
    // 메뉴 미배정 계정 안내 화면
    NoMenuAccess: {
        path: '/no-menu',
        name: 'NoMenuAccess',
    },
    // 제품라인 라벨 매핑 관리 (SPEC-CHINA-PRODUCT-LINE-MAPPING-001)
    ProductLineMapping: {
        path: '/product-line-mapping',
        name: 'ProductLineMapping',
    },
    // 위챗 사용자 정합 관측 (SPEC-CHINA-FOLLOW-SYNC-001 M4, XINLAIAN 전용)
    FollowSync: {
        path: '/china/follow-sync',
        name: 'FollowSyncDashboard',
    },
    // GEO 지표관리 (SPEC-CHINA-GEO-ADMIN-001 Phase 1)
    Geo: {
        path: '/china/geo',
        name: 'Geo',
        Dashboard: {
            path: 'dashboard',
            name: 'GeoDashboard',
        },
        // 엔진·세션 관리(시스템 설정) — GeoDashboard.vue에서 CRUD 분리(IA 점검 P0)
        EngineSessions: {
            path: 'engine-sessions',
            name: 'GeoEngineSessions',
        },
        QuestionSets: {
            path: 'question-sets',
            name: 'GeoQuestionSets',
        },
        Hospitals: {
            path: 'hospitals',
            name: 'GeoHospitals',
        },
        Runs: {
            path: 'runs',
            name: 'GeoRuns',
        },
        // 수집 회차 상세 — 드로어를 대체하는 전용 페이지(공유 가능한 URL + 요약 통계)
        RunDetail: {
            path: 'runs/:runId',
            name: 'GeoRunDetail',
        },
        // 병원 콘텐츠 CMS 편집 — 진입은 브랜드 허브 ②/③ CTA 하나뿐이다.
        // 구 목록 화면(GeoCms)과 v1 편집(GeoCmsEdit)은 제거했다(생성은 허브 셀렉터가 소유).
        CmsEditV2: {
            path: 'cms/v2/:companyId',
            name: 'GeoCmsEditV2',
        },
        // 원문 자료 관리 (SPEC-CHINA-GEO-SOURCE-TEXT-001) — 진입은 브랜드 허브 ① 원문 CTA.
        SourceText: {
            path: 'sources/:companyId',
            name: 'GeoSourceText',
        },
        // LLM 사용량 — 회사별 과금 원장 조회 (SPEC-CHINA-GEO-LLM-GATEWAY-001).
        // 조회 전용. 원장은 append-only라 이 화면에 쓰기 동선이 없다.
        LlmUsage: {
            path: 'llm-usage',
            name: 'GeoLlmUsage',
        },
        // 자료실 검토 (SPEC-CHINA-GEO-MEDIA-REVIEW-001) — 진입은 브랜드 허브 ① 자료실 CTA.
        // 편집 드로어의 자료실 탭은 "쓰는" 동선으로 그대로 남는다(구현은 동일 컴포넌트).
        MediaReview: {
            path: 'media/:companyId',
            name: 'GeoMediaReview',
        },
        Compliance: {
            path: 'compliance',
            name: 'GeoCompliance',
        },
        // 브랜드 허브 (SPEC-CHINA-GEO-HUB-001 M2) — 6화면 보존 + 브랜드 축 조율 레이어
        Hub: {
            path: 'hub',
            name: 'GeoHub',
        },
        HubDetail: {
            path: 'hub/:companyId',
            name: 'GeoHubDetail',
        },
    },
    // Dealer GSP ETL (SPEC-DEALER-GSP-ETL-001 Phase β)
    DealerGsp: {
        path: '/dealer-gsp',
        name: 'DealerGsp',
        Dashboard: {
            path: 'dashboard',
            name: 'DealerGspDashboard',
        },
        PurchaseInbounds: {
            path: 'purchase-inbounds',
            name: 'DealerGspPurchaseInbounds',
        },
        SalesOutbounds: {
            path: 'sales-outbounds',
            name: 'DealerGspSalesOutbounds',
        },
        InventorySnapshots: {
            path: 'inventory-snapshots',
            name: 'DealerGspInventorySnapshots',
        },
        EtlRuns: {
            path: 'etl-runs',
            name: 'DealerGspEtlRuns',
        },
        CronConsole: {
            path: 'cron-console',
            name: 'DealerGspCronConsole',
        },
    },
    // 멤버십 관리 — 운영자 전용 (SPEC-CHINA-IAM-CORE-001)
    // [2026-08-04] SPEC-CHINA-IAM-CONSOLE-001: 화면은 폐기되고 /iam으로 리다이렉트만 남는다.
    // path/name은 리다이렉트 라우트 선언에 계속 쓰이므로 유지한다.
    Memberships: {
        path: '/memberships',
        name: 'Memberships',
    },
    // IAM 콘솔 — 계정·소속·권한 통합 단일 화면 (SPEC-CHINA-IAM-CONSOLE-001)
    IamConsole: {
        path: '/iam',
        name: 'IamConsole',
    },
    // 자기 회사 정보 수정(self-service) — 병원·기공소 공용 (SPEC-CHINA-IAM-CORE-001)
    CompanyProfile: {
        path: '/company-profile',
        name: 'CompanyProfile',
    },
    // 구 병원 전용 경로 — 폐기, /company-profile로 리다이렉트.
    // DB menus 행의 link를 바꾸는 작업과 FE 배포는 시점이 분리되므로 경로를 즉시 지우면
    // 둘 사이 구간에서 병원 계정의 사이드바 링크가 깨진다. 북마크 보호도 겸한다.
    HospitalProfile: {
        path: '/hospital-profile',
        name: 'HospitalProfile',
    },
}